/* eslint-disable no-undef */
import React from 'react'
import { compose, lifecycle, withProps } from 'recompose'
import { withScriptjs } from 'react-google-maps'
import { StandaloneSearchBox } from 'react-google-maps/lib/components/places/StandaloneSearchBox'
import { Input } from 'antd'

const PlacesWithStandaloneSearchBox = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyDAVABqCUc0PckLw4iit70FAtL6kBko7PE&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}
      this.setState({
        places: [],
        bounds: new google.maps.LatLngBounds(
          new google.maps.LatLng(26.435387, 22.934393),
          new google.maps.LatLng(52.070952, 56.915103)
        ),
        onSearchBoxMounted: (ref) => {
          refs.searchBox = ref
        },
        // componentDidMount () {
        //   // This interval is to check when the map is completely loaded
        //   const interval = window.setInterval(() => {
        //     if (this.map) {
        //       const input = document.getElementById('searchInputControl')
        //       this.autocomplete = new google.maps.places.Autocomplete(input)
        //       this.autocomplete.setComponentRestrictions({country: 'au'})
        //       this.autocomplete.addListener('place_changed', this.handleSearchBoxPlacesChanged)
        //
        //       window.clearInterval(interval)
        //     }
        //   }, 500)
        // }
        // ,
        // handleSearchBoxPlacesChanged () {
        //   const place = this.autocomplete.getPlace()
        // },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces()
          const {
            place_id,
            formatted_address,
            geometry: { location },
          } = places[0]
          this.props.onChange({
            lat: location.lat(),
            place_id,
            address: formatted_address,
            lng: location.lng(),
          })
          this.setState({
            places,
          })
        },
      })
    },
  }),
  withScriptjs
)((props) => {
  return (
    <StandaloneSearchBox
      ref={props.onSearchBoxMounted}
      bounds={props.bounds}
      strictBounds={true}
      onPlacesChanged={props.onPlacesChanged}>
      <Input key={props.key} style={props.style} placeholder="Search New Location" />
    </StandaloneSearchBox>
  )
})
export default PlacesWithStandaloneSearchBox
